import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { RootState } from "app/store";
import { ApiResponse } from "models";

const initialState: any = {
  loading: false,
  success: false,
  message: "",
  addRoleLoading: false,
  addRoleMessage: "",
  updateRoleLoading: false,
  updateRoleMessage: "",
  deleteRoleloading: false,
  deleteRoleMessage: "",
  data: {},
  moduledata: {},
  listByIdLoading: false,
  listByIdSuccess: false,
  listByIdData: {},
  roleByIdLoading: false,
  roleByIdSuccess: false,
  roleByIdData: {},
  allPermissions: [],
  allPermissionsLoading: false,
};

const accessRoleSlice = createSlice({
  name: "adminUserMgmtAccessRole",
  initialState,
  reducers: {
    getAccessRoleList(state, action: PayloadAction<ApiResponse>) {
      state.loading = true;
      state.message = "";
    },
    getAccessRoleListSuccess(state, action: PayloadAction<any>) {
      state.loading = false;
      state.data = action.payload;
      state.success = action.payload.success;
    },
    getAccessRoleListFailed(state, action: PayloadAction<ApiResponse>) {
      state.loading = false;
      state.data = {};
      state.message = action.payload?.message;
      state.success = action.payload?.success;
    },
    getAccessRoleById(state, action: PayloadAction<ApiResponse>) {
      state.roleByIdLoading = true;
      state.roleByIdSuccess = false;
    },
    getAccessRoleByIdSuccess(state, action: PayloadAction<any>) {
      state.roleByIdLoading = false;
      state.roleByIdData = action.payload.data;
      state.roleByIdSuccess = action.payload.success;
    },
    getAccessRoleByIdFailed(state, action: PayloadAction<ApiResponse>) {
      state.roleByIdLoading = false;
      state.roleByIdData = {};
      state.roleByIdSuccess = action.payload?.success;
    },
    getModuleList(state, action: PayloadAction<ApiResponse>) {
      state.loading = true;
      state.message = "";
    },
    getModuleListSuccess(state, action: PayloadAction<any>) {
      state.loading = false;
      state.moduledata = action.payload;
      state.success = action.payload.success;
    },
    getModuleListFailed(state, action: PayloadAction<ApiResponse>) {
      state.loading = false;
      state.moduledata = {};
      state.message = action.payload?.message;
      state.success = action.payload?.success;
    },
    getModuleById(state, action: PayloadAction<ApiResponse>) {
      state.listByIdLoading = true;
      state.listByIdData = {};
      state.listByIdSuccess = false;
    },
    getModuleByIdSuccess(state, action: PayloadAction<ApiResponse>) {
      state.listByIdLoading = false;
      state.listByIdData = action.payload.data;
      state.listByIdSuccess = action.payload.success;
    },
    getModuleByIdFailed(state, action: PayloadAction<ApiResponse>) {
      state.listByIdLoading = false;
      state.listByIdData = action.payload.data;
      state.listByIdSuccess = action.payload.success;
    },
    addAccessRole(state, action: PayloadAction<ApiResponse>) {
      state.addRoleLoading = true;
      state.addRoleMessage = "";
    },
    addAccessRoleSuccess(state, action: PayloadAction<ApiResponse>) {
      state.addRoleLoading = false;
      state.addRoleMessage = action.payload.message;
      state.success = action.payload.success;
    },
    addAccessRoleFailed(state, action: PayloadAction<ApiResponse>) {
      state.addRoleLoading = false;
      state.message = action.payload.message;
      state.success = action.payload.success;
    },
    updateAccessRole(state, action: PayloadAction<ApiResponse>) {
      state.updateRoleLoading = true;
      state.updateRoleMessage = "";
    },
    updateAccessRoleSuccess(state, action: PayloadAction<ApiResponse>) {
      state.updateRoleLoading = false;
      state.updateRoleMessage = action.payload.message;
      state.success = action.payload.success;
    },
    updateAccessRoleFailed(state, action: PayloadAction<ApiResponse>) {
      state.updateRoleLoading = false;
      state.updateRoleMessage = action.payload.message;
      state.success = action.payload.success;
    },
    deleteAccessRole(state, action: PayloadAction<ApiResponse>) {
      state.deleteRoleloading = true;
      state.deleteMessage = "";
    },
    deleteAccessRoleSuccess(state, action: PayloadAction<ApiResponse>) {
      state.deleteRoleloading = false;
      state.deleteRoleMessage = action.payload.message;
      state.success = action.payload.success;
    },
    deleteAccessRoleFailed(state, action: PayloadAction<ApiResponse>) {
      state.deleteRoleloading = false;
      state.deleteRoleMessage = action.payload.message;
      state.success = action.payload.success;
    },
    clearData(state) {
      state.loading = false;
      state.success = false;
      state.message = "";
      state.addRoleLoading = false;
      state.addRoleMessage = "";
      state.updateRoleLoading = false;
      state.updateRoleMessage = "";
      state.deleteRoleloading = false;
      state.deleteRoleMessage = "";
    },
    getAllPermissions(state) {
      state.allPermissionsLoading = true;
    },
    getAllPermissionsSuccess(state, action: PayloadAction<any>) {
      state.allPermissionsLoading = false;
      state.allPermissions = action.payload.data || [];
    },
    getAllPermissionsFailed(state, action: PayloadAction<ApiResponse>) {
      state.allPermissionsLoading = false;
    },
  },
});

//Actions
export const adminUserMgmtAccessRoleActions = accessRoleSlice.actions;

//Selectors
export const getAccessRoleList = (state: RootState) => state.adminUserMgmtAccessRole.data;
export const getAccessRoleById = (state: RootState) =>
  state.adminUserMgmtAccessRole.roleByIdData;
export const getModuleList = (state: RootState) => state.adminUserMgmtAccessRole.moduledata;
export const getModuleById = (state: RootState) =>
  state.adminUserMgmtAccessRole.listByIdData;
export const selecetMessage = (state: RootState) => state.adminUserMgmtAccessRole.message;
export const selectSuccess = (state: RootState) => state.adminUserMgmtAccessRole.success;
export const selectLoading = (state: RootState) => state.adminUserMgmtAccessRole.loading;
export const selectAddRoleLoading = (state: RootState) =>
  state.adminUserMgmtAccessRole.addRoleLoading;
export const selectAddRoleMessage = (state: RootState) =>
  state.adminUserMgmtAccessRole.addRoleMessage;
export const selectUpdateRoleLoading = (state: RootState) =>
  state.adminUserMgmtAccessRole.updateRoleLoading;
export const selectUpdateRoleMessage = (state: RootState) =>
  state.adminUserMgmtAccessRole.updateRoleMessage;
export const selectDeleteRoleLoading = (state: RootState) =>
  state.adminUserMgmtAccessRole.deleteRoleloading;
export const selectDeleteRoleMessage = (state: RootState) =>
  state.adminUserMgmtAccessRole.deleteRoleMessage;

export const selectAllPermissions = (state: RootState) => state.adminUserMgmtAccessRole.allPermissions;
export const selectAllPermissionsLoading = (state: RootState) => state.adminUserMgmtAccessRole.allPermissionsLoading;

//Reducers
const adminUserMgmtAccessRoleReducer = accessRoleSlice.reducer;
export default adminUserMgmtAccessRoleReducer;
